import api from "../../../services/axiosConfig";

export const fetchUsers = async () => {
  try {
    const response = await api.get("/instances/skeye/skeyecube/list-users", {
      data: {},
    });
    const usersString = response.data.data.users;
    const usersObj =
      typeof usersString === "string" ? JSON.parse(usersString) : {};
    const usersRaw = Array.isArray(usersObj.data?.users)
      ? usersObj.data.users
      : [];

    const users = usersRaw.map((u, idx) => ({
      id: u.uuid || idx,
      name: u.username,
      groups: Array.isArray(u.authorities)
        ? u.authorities.map((a) =>
            a.authority.replace("ROLE_", "").toLowerCase(),
          )
        : [],
      disabled: u.disabled,
    }));

    return users;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const addUser = async (userData) => {
  try {
    const response = await api.post(
      "/instances/skeye/skeyecube/create-user",
      userData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};

export const toggleUserStatus = async (username, disabled) => {
  try {
    const response = await api.put(
      `/instances/skeye/skeyecube/enable-disable-user/${username}`,
      { disabled: !disabled },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error toggling user status:", error);
    throw error;
  }
};

export const changeUserPassword = async (
  username,
  newPassword,
  repeatPassword,
) => {
  try {
    const response = await api.put(
      "/instances/skeye/skeyecube/change-password",
      {
        username: username,
        newPassword: newPassword,
        repeatPassword: repeatPassword,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};

export const updateUserAuthorities = async (username, userData) => {
  try {
    const response = await api.put(
      `/instances/skeye/skeyecube/update-user-authorities/${username}`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user authorities:", error);
    throw error;
  }
};
